import React from 'react';
import { resolveSlotComponent } from '../ComponentRegistry.jsx';
import { SidebarFilterLayout } from '../components/filters/SidebarFilterLayout.jsx';

export function FilterSlot({
  variant,
  tenant,
  categories,
  activeCategory,
  activeSubcategory,
  onSelectCategory,
  onSelectSubcategory,
  search,
  onSearchChange,
  onSearchSubmit,
  manufacturers,
  selectedManufacturer,
  onSelectManufacturer,
  sort,
  onSortChange,
  onResetFilters,
  ...props
}) {
  const requestedVariant =
    variant ||
    tenant?.settings?.filter_layout ||
    tenant?.filter_layout ||
    'sidebar';

  const FilterComponent = resolveSlotComponent('filter', requestedVariant) || SidebarFilterLayout;

  return (
    <FilterComponent
      tenant={tenant}
      categories={categories}
      activeCategory={activeCategory}
      activeSubcategory={activeSubcategory}
      onSelectCategory={onSelectCategory}
      onSelectSubcategory={onSelectSubcategory}
      search={search}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      manufacturers={manufacturers}
      selectedManufacturer={selectedManufacturer}
      onSelectManufacturer={onSelectManufacturer}
      sort={sort}
      onSortChange={onSortChange}
      onResetFilters={onResetFilters}
      {...props}
    />
  );
}
